import { render, staticRenderFns } from "./SwitchCamera.vue?vue&type=template&id=30f6fd74"
import script from "./SwitchCamera.vue?vue&type=script&lang=js"
export * from "./SwitchCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports